import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useContext, useEffect, useState } from 'react';
import AdjustContext from '../../../utils/adjustContext';
import { ADJUST_EVENTS, EVENTS, sendEvent } from '../../../utils/analytics';
import { useLocalStorageState } from '../../../utils/hooks';

type Props = {
  className?: string;
  imageHeight?: string;
  creative: string;
  campaign?: string;
};

const BadgeImg = styled.img<{ height: string }>`
  ${({ height }) => height && `height: ${height};`}
  display: inline-block;
  width: 120px;
`;

const AppStoreBadge = ({
  className,
  imageHeight = '40px',
  creative,
  campaign = 'default',
}: Props) => {
  const [utmTags] =
    useLocalStorageState<{ utm_campaign?: string; utm_source?: string }>('latest-utm-tags');
  const [utmCampaign, setUtmCampaign] = useState<string>(campaign);
  const [utmSource, setUtmSource] = useState<string>('default');
  const adjust = useContext(AdjustContext);

  useEffect(() => {
    if (utmTags?.utm_campaign) {
      setUtmCampaign(utmTags.utm_campaign);
    }
    if (utmTags?.utm_source) {
      setUtmSource(utmTags.utm_source);
    }
  }, [utmTags]);

  const goToMarket = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    adjust?.trackEvent({
      eventToken: ADJUST_EVENTS.clickAppDownload.token,
    });

    sendEvent(EVENTS.clickAppDownload.name, {
      creative,
      campaign,
      'store name': 'app store',
    });
    const target = event.currentTarget;
    const location = target.getAttribute('href');
    if (location) {
      window.location.href = location;
    }
  };

  return (
    <a
      onClick={(e) => goToMarket(e)}
      className={className}
      css={css`
        cursor: pointer;
      `}
      aria-label="Download on the App store."
      rel="preconnect"
      href={`https://app.adjust.com/hfd6e8n?campaign=${encodeURIComponent(
        utmCampaign,
      )}&adgroup=${encodeURIComponent(utmSource)}&creative=${encodeURIComponent(
        creative,
      )}&engagement_type=fallback_click&fallback=https%3A%2F%2Fapps.apple.com%2Fapp%2Fmilkywire-make-an-impact%2Fid1454800179`}
    >
      <BadgeImg
        loading="lazy"
        height={imageHeight}
        alt="Download on the App store."
        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1562716800&h=6c810127aa2c53fe6a6c4fa5023ae383"
      />
    </a>
  );
};
export default AppStoreBadge;
